export default "__VITE_ASSET__BP6dYP4q__"